import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(
    private session: StorageService,
  ) { 
    
  }
  storage = this.session
  commonContent;
  content;
  ngOnInit(): void {
    setTimeout(()=>{
      this.content = this.session.resource?.footer;
      this.commonContent = this.session.resource?.footer;
    },100)

  }

}
